import { genericService } from "./genericService";

const section = "Client";

function filter(name = " ", from = "0", limit = "10", active = "1") {
  return genericService.filter(section, "clients", name, from, limit, active);
}

function remove(id) {
  return genericService.remove(section, id);
}

function getAll() {
  return genericService.get("Client/ListAllClient");
}

function create(item) {
  const param = {
    nameClient: item.nameClient,
    cuit: item.cuit,
    clientAddress: item.clientAddress,
    clientTelephone: item.clientTelephone,
    clientEmail: item.clientEmail,
    contact: item.contact,
    paymentType: item.paymentType.id,
    priceUnit: parseFloat(item.priceUnit),
    idSaleRate: item.saleRate.id,
    isActive: item.isActive,
  };
  return genericService.create(section, param);
}

function update(item) {
  const param = {
    id: item.id,
    nameClient: item.nameClient,
    cuit: item.cuit,
    clientAddress: item.clientAddress,
    clientTelephone: item.clientTelephone,
    clientEmail: item.clientEmail,
    contact: item.contact,
    paymentType: item.paymentType.id,
    priceUnit: parseFloat(item.priceUnit),
    idSaleRate: item.saleRate.id,
    isActive: item.isActive,
  };
  return genericService.update(section, param);
}

export const clientService = {
  getAll,
  filter,
  remove,
  create,
  update,
};
